
import PasswordCrypter from '@/utils/password-crypter.js'
import AppException from '@/utils/AppException'

import AuthService from './services/AuthService'
import AdministratorService from './services/AdministratorService'
import FirebaseService from './services/FirebaseService'
import ContentTemplateService from './services/ContentTemplateService'
import WebInfoService from './services/WebInfoService'
import MessageService from './services/MessageService'
import PostTagService from './services/PostTagService'
import PostService from './services/PostService'
import WorkService from './services/WorkService'

import Config from '@/assets/js/config.js'

export default class Services {
  static shared = new Services()

  constructor () {
    let passwordCrypter = new PasswordCrypter(Config.SaltBefore, Config.SaltAfter)

    this.auth = new AuthService(passwordCrypter)
    this.administrator = new AdministratorService(passwordCrypter)
    this.firebase = new FirebaseService()
    this.contentTemplate = new ContentTemplateService()
    this.webInfo = new WebInfoService()
    this.message = new MessageService()
    this.post = new PostService()
    this.postTag = new PostTagService()
    this.work = new WorkService()
  }

  fetchDatas (vm) {
    return Promise.all([
      this.administrator.getMe(vm).then(o => { vm.isLoading = true; return o }),
      this.contentTemplate.getAll(vm).then(o => { vm.isLoading = true; return o }),
      this.webInfo.getAll(vm).then(o => { vm.isLoading = true; return o }),
      this.message.getAll(vm).then(o => { vm.isLoading = true; return o })
    ]).then(results => {
      let admin = results[0].data.result
      let contentTemplateList = results[1].data.result
      let webInfoList = results[2].data.result
      let messageList = results[3].data.result

      // vuex
      vm.$store.state.contentTemplate.list = contentTemplateList
      vm.$store.state.admin = admin
      vm.$store.state.webInfo.list = webInfoList
      vm.$store.state.message.list = messageList
    }).finally(() => {
      vm.isLoading = false
    })
  }

  fetchWorkDatas (vm) {
    if (vm.$store.state.work.isFetching) throw new AppException('正在讀取中')
    vm.$store.state.work.isFetching = true
    return Promise.all([
      this.work.getAll(vm).then(o => { vm.isLoading = true; return o })
    ]).then(results => {
      let workList = results[0].data.result

      // vuex
      vm.$store.state.work.list = workList

      vm.$store.state.work.isFetched = true
    }).finally(() => {
      vm.isLoading = false
      vm.$store.state.work.isFetching = false
    })
  }

  fetchPostDatas (vm) {
    if (vm.$store.state.post.isFetching) throw new AppException('正在讀取中')
    vm.$store.state.post.isFetching = true
    return Promise.all([
      this.post.getAll(vm).then(o => { vm.isLoading = true; return o }),
      this.postTag.getAll(vm).then(o => { vm.isLoading = true; return o })
    ]).then(results => {
      let postList = results[0].data.result
      let postTagList = results[1].data.result

      // 計算標籤使用程度
      this.postTag.calcuateUsedTimes(postTagList, postList)

      // vuex
      vm.$store.state.post.list = postList
      vm.$store.state.post.tagList = postTagList
      vm.$store.state.post.commonlyUsedTagList = this.postTag.findCommonlyUsedList(postTagList)

      vm.$store.state.post.isFetched = true
    }).finally(() => {
      vm.isLoading = false
      vm.$store.state.post.isFetching = false
    })
  }

  alertResultError (vm, res) {
    var msg = '未知的錯誤'
    if (res && res.data && res.data.error) msg = res.data.error
    vm.$alert(msg, '錯誤', {
      confirmButtonText: '確認',
      type: 'error'
    })
  }

  alertError (vm, err) {
    console.error(err)
    var msg = err
    if (err.response && err.response.data && err.response.data.error) msg = err.response.data.error
    else if (err.response) msg = (err.response.status || '') + ' ' + (err.response.statusText || '沒有錯誤訊息')
    else msg = '未知的錯誤'

    vm.$alert(msg, '錯誤', {
      confirmButtonText: '確認',
      type: 'error'
    })
  }
}
